import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAjK40bMsXY2nxmrrVNiWcd8f88Tpf8ELI",
  authDomain: "global-access-trades.firebaseapp.com",
  projectId: "global-access-trades",
  storageBucket: "global-access-trades.appspot.com",
  messagingSenderId: "870235119648",
  appId: "1:870235119648:web:099cfe17e207ef3f959c45",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
